export default __webpack_public_path__ + "static/media/Slide12.51554a29.JPG";